import { FC, useState, useEffect } from 'react';
import { Divider, Modal, OutlineButton, PrimaryButton } from 'shared';
import SingleCheckBox from 'shared/ui/SingleCheckBox';
import store from 'store';

interface IProps {
  open: boolean;
  onContinue: () => void | Promise<void>;
  onClose: () => void | Promise<void>;
}

export const CreditsExhaustedModal: FC<IProps> = ({
  open,
  onContinue,
  onClose
}) => {
  const [skipModal, setSkipModal] = useState<boolean>(
    store.get('skipCreditsExhaustedModal', false)
  );

  const [localSkipModal, setLocalSkipModal] = useState<boolean>(skipModal);

  useEffect(() => {
    if (open && skipModal) {
      onContinue();
    }
  }, [open, skipModal, onContinue]);

  const handleSkipModal = () => {
    const newValue = !localSkipModal;
    setLocalSkipModal(newValue);
  };

  const handleContinue = () => {
    if (localSkipModal) {
      store.set('skipCreditsExhaustedModal', true);
      setSkipModal(true);
    }
    onContinue();
  };

  if (skipModal && !open) {
    return null;
  }

  return (
    <Modal
      open={open && !skipModal}
      onClose={onClose}
      noPadding
      widthClasses="yep_ex-w-[18rem] sm:yep_ex-w-96"
    >
      <div className="yep_ex-text-center">
        <h3 className="yep_ex-text-lg yep_ex-font-semibold yep_ex-py-5">
          Credits Exhausted
        </h3>
        <Divider />
        <div className="yep_ex-p-4">
          <p className="yep_ex-text-sm yep_ex-text-gray-700">
            Your credits are insufficient.
            <br /> Further actions will incur a cost of <b>$0.2 per credit.</b>
          </p>
          <div className="yep_ex-flex yep_ex-py-0.5 yep_ex-gap-3 yep_ex-items-center yep_ex-my-1">
            <SingleCheckBox
              label="Don’t show me this again."
              onClick={handleSkipModal}
              value={localSkipModal}
              className="yep_ex-text-neutral-700 yeo_ex-font-medium yep_ex-leading-normal"
            />
          </div>
          <div className="yep_ex-mt-4 yep_ex-flex yep_ex-justify-center yep_ex-gap-4">
            <OutlineButton
              className="yep_ex-flex-1 focus:yep_ex-outline-primary-600"
              onClick={onClose}
            >
              Cancel
            </OutlineButton>
            <PrimaryButton
              type="button"
              className="yep_ex-flex-1 focus:yep_ex-outline-white yep_ex-flex yep_ex-justify-center yep_ex-items-center"
              onClick={handleContinue}
            >
              Continue
            </PrimaryButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};
